import $ from 'jquery';

var CREATE_FORM_SELECTOR = '.js-clans_create_form';
var CONFIRM_CREATE_BUTTON_SELECTOR = '.js-clans_button__confirm-create';
var CONFIRM_CREATE_VALIDATION_LIST_SELECTOR = '.js-confirm-create-validation-list';
var CREATE_CONFIRMED_BUTTON_SELECTOR = '.js-clans_button__create-confirmed';


var $modal;
var $createForm;
var $confirmCreateButton;
var $nameField;
var $tagField;
var $recruitingPolicyField;


var copyValue = function (fieldName, customHandler) {
    var destSelector = '.clans_field[data-field-name=' + fieldName + ']';
    var source = $createForm.find(clans.getFormFieldSelector(fieldName));
    var dest = $modal.find(destSelector);

    if (customHandler)
        customHandler(source, dest);
    else
        dest.text(source.val());
};

var showCreateConfirmModal = function () {
    var $this = $(this);
    if ($this.is(clans.FORMS_BUTTON_DISABLED_SELECTOR) || !validate())
        return;

    wg_errors.clearErrors();

    $(CONFIRM_CREATE_BUTTON_SELECTOR).addClass(clans.FORMS_BUTTON_DISABLED_CLASS);

    var element = jQuery('.js-clans_create_confirm');
    $modal = element.showAsModal({
        dismissible: true,
        createClone: true,
        onClose: function () {

            $(CONFIRM_CREATE_BUTTON_SELECTOR).removeClass(clans.FORMS_BUTTON_DISABLED_CLASS);

        }
    });

    copyValue('name');
    copyValue('tag');
    copyValue('recruiting_policy', function (source, dest) {
        dest.text(source.filter(':checked').parent().text());
    });

    $modal.find(CREATE_CONFIRMED_BUTTON_SELECTOR).on('click tap', create);

};
var create = function () {

    $modal.close();

    $(CONFIRM_CREATE_BUTTON_SELECTOR).addClass(clans.FORMS_BUTTON_DISABLED_CLASS);
    wg_modal.showThrobber();

    var data = {
        name: $nameField.val(),
        tag: $tagField.val(),
        recruiting_policy: $recruitingPolicyField.filter(':checked').val()
    };
    clans.callEndpoint({
        endpoint: "create",
        data: data,
        success: null, // Should be redirected to clan page from server redirect
        failure: null, // default handler will show error and hide throbber
        complete: function () {
            $(CONFIRM_CREATE_BUTTON_SELECTOR).removeClass(clans.FORMS_BUTTON_DISABLED_CLASS);
        }
    });

};

var validate = function () {
    var $validationList = $confirmCreateButton.find(
        CONFIRM_CREATE_VALIDATION_LIST_SELECTOR
    );
    $validationList.empty();
    window.tooltipReset();

    var validation_results = clans.validateClan(
        $validationList,
        $nameField,
        $tagField,
        $recruitingPolicyField
    );
    console.log(validation_results);

    var valid = validation_results.children().length == 0;

    $confirmCreateButton.toggleClass(clans.FORMS_BUTTON_DISABLED_CLASS, !valid);
    $confirmCreateButton.toggleClass('js-mobile-tooltip', !valid);

    return valid;
};

export function clans_add_event_handlers_to_tag_field(tag_regex, tag_field_id) {
    var INPUT_WRAPPER_CLASS = 'forms_input_wrapper forms_input_wrapper__full-width';
    var INPUT_WRAPPER_CHECKING_CLASS = 'forms_input_wrapper__checking';

    var tagInvalidCharRegex = /[^A-Za-z0-9 _\-]/gu;
    //var tagInvalidCharRegex = /(?!({{ clan_tag_char_regex }}))./g;
    var $tagField = $('#' + tag_field_id);

    var uniqueCheck;
    var uniqueCheckTimeout;

    $tagField.wrap($('<div>').addClass(INPUT_WRAPPER_CLASS));

    $tagField.on('input propertychange', function (ev) {
        var val = $tagField.val();

        if (val.length == 0) {
            $('.js-clans_tag_validation').hide();
        } else {

            $tagField.addClass('validating');

            var valUcase = val.toUpperCase();
            var $uppercaseValidationMessage = $('.js-clans_tag_validation__uppercase');
            var $charValidationMessage = $('.js-clans_tag_validation__chars');
            var $lengthValidationMessage = $('.js-clans_tag_validation__length');
            var $uniqueValidationMessage = $('.js-clans_tag_validation__unique');
            var $inTransactionValidationMessage = $('.js-clans_tag_validation__in-transaction');
            var $badwordValidationMessage = $('.js-clans_tag_validation__badword');

            var invalidChars = valUcase.match(tagInvalidCharRegex);

            if (invalidChars) {
                invalidChars = invalidChars.filter(function (item, pos) {
                    return invalidChars.indexOf(item) == pos;
                });
                invalidChars[invalidChars.indexOf(" ")] = "<gettext('space')>";
                invalidChars[invalidChars.indexOf("\t")] = "<gettext('tab')>";

                $charValidationMessage.find('.js-clans_tag_validation__chars-echo')
                    .text(invalidChars.join(', '));
            }
            var validCase = val == valUcase;
            var validChars = invalidChars == null;
            var validLength = valUcase.length >= 2 && valUcase.length <= 5;
            var isDifferent = val != $tagField.prop("defaultValue");

            if (!validCase)
                $uppercaseValidationMessage.show();
            else if ($tagField.is('.validating'))
                $uppercaseValidationMessage.hide();

            $charValidationMessage.toggle(!validChars).toggleClass('invalid', !validChars);
            $lengthValidationMessage.toggle(!validLength).toggleClass('invalid', !validLength);
            $uniqueValidationMessage.hide().removeClass('invalid');
            $inTransactionValidationMessage.hide().removeClass('invalid');

            if (uniqueCheckTimeout)
                clearTimeout(uniqueCheckTimeout);

            if (validLength && validChars) {
                if (isDifferent) {
                    $uniqueValidationMessage.addClass('invalid');
                    uniqueCheckTimeout = setTimeout(function () {

                        if (uniqueCheck && uniqueCheck.xhr)
                            uniqueCheck.xhr.abort();

                        $tagField.parent().addClass(INPUT_WRAPPER_CHECKING_CLASS);
                        uniqueCheck = clans.callEndpoint({
                            endpoint: "check_availability",
                            data: {
                                tag: valUcase
                            },
                            success: function (data) {

                                if (data.tag == 'taken') {
                                    $uniqueValidationMessage.show().addClass('invalid');
                                } else if (data.tag == 'in_transaction') {
                                    $inTransactionValidationMessage.show().addClass('invalid');
                                } else {
                                    if (data.badWords) {
                                        $badwordValidationMessage.show().addClass('invalid');
                                    } else {
                                        $badwordValidationMessage.hide().removeClass('invalid');
                                        if (data.tag == 'available') {
                                            // Available!!
                                            $uniqueValidationMessage.hide().removeClass('invalid');
                                            $inTransactionValidationMessage.hide().removeClass('invalid');
                                        } else {
                                            wg_errors.showError(gettext("Unable to verify if tag is unique"));
                                        }
                                    }
                                }
                                $tagField.removeClass('validating');
                                $tagField.trigger('validated');
                            },
                            failure: function (data) {
                                $uniqueValidationMessage.hide().removeClass('invalid');
                                $inTransactionValidationMessage.hide().removeClass('invalid');
                                $tagField.trigger('validated');
                                clans.showErrorFromApiResponse(data);
                            },
                            complete: function () {
                                $tagField.parent().removeClass(INPUT_WRAPPER_CHECKING_CLASS);
                            }
                        });
                    }, 400);
                }
            }

            var elem = $tagField[0];
            var start = elem.selectionStart;
            var end = elem.selectionEnd;

            $tagField.val(valUcase); // val() resets the selection/cursor so we save it then reload it

            elem.setSelectionRange(start, end);

            $tagField.trigger('validated');
        }
    }).trigger('input');
}

export function clans_add_event_handlers_to_name_field(name_field_id) {
    var INPUT_WRAPPER_CLASS = 'forms_input_wrapper forms_input_wrapper__full-width ';
    var INPUT_WRAPPER_CHECKING_CLASS = 'forms_input_wrapper__checking';

    var nameInvalidCharRegex = /[^A-Za-z0-9 _\-]/gu;
    var $nameField = $('#' + name_field_id);
    var uniqueCheck;
    var uniqueCheckTimeout;

    $nameField.wrap($('<div>').addClass(INPUT_WRAPPER_CLASS));

    $nameField.on('input propertychange', function (ev) {
        var val = $nameField.val().trim();

        if (val.length == 0) {
            $('.clans_name_validation').hide();
        } else {
            var $lengthValidationMessage = $('.js-clans_name_validation__length');
            var $uniqueValidationMessage = $('.js-clans_name_validation__unique');
            var $inTransactionValidationMessage = $('.js-clans_name_validation__in-transaction');
            var $badwordValidationMessage = $('.js-clans_name_validation__badword');
            var $charValidationMessage = $('.js-clans_name_validation__chars');
            var isDifferent = clans.isChanged($nameField, true);

            var validLength = val.length >= 2 && val.length <= clans.MAX_CLAN_NAME_LENGTH;

            var valUcase = val.toUpperCase(); // keep or drop depending on if you normalize case

            var invalidChars = valUcase.match(nameInvalidCharRegex);

            if (invalidChars) {
                invalidChars = invalidChars.filter(function (item, pos) {
                    return invalidChars.indexOf(item) == pos;
                });
                if (invalidChars.includes(" ")) invalidChars[invalidChars.indexOf(" ")] = "<{{ _('space') }}>";
                if (invalidChars.includes("\t")) invalidChars[invalidChars.indexOf("\t")] = "<{{ _('tab') }}>";

                $('.js-clans_name_validation__chars')
                    .find('.js-clans_name_validation__chars-echo')
                    .text(invalidChars.join(', '));
            }

            $charValidationMessage.toggle(!!invalidChars).toggleClass('invalid', !!invalidChars);

            $lengthValidationMessage.toggle(!validLength).toggleClass('invalid', !validLength);
            $uniqueValidationMessage.hide().removeClass('invalid');
            $inTransactionValidationMessage.hide().removeClass('invalid');

            if (uniqueCheckTimeout)
                clearTimeout(uniqueCheckTimeout);

            if (validLength) {
                if (isDifferent) {
                    $uniqueValidationMessage.addClass('invalid');
                    uniqueCheckTimeout = setTimeout(function () {

                        if (uniqueCheck && uniqueCheck.xhr)
                            uniqueCheck.xhr.abort();

                        $nameField.parent().addClass(INPUT_WRAPPER_CHECKING_CLASS);

                        uniqueCheck = clans.callEndpoint({
                            endpoint: "check_availability",
                            data: {
                                name: val
                            },
                            success: function (data) {

                                if (data.name == 'taken') {
                                    $uniqueValidationMessage.show().addClass('invalid');
                                } else if (data.name == 'in_transaction') {
                                    $inTransactionValidationMessage.show().addClass('invalid');
                                } else {
                                    if (data.badWords) {
                                        $badwordValidationMessage.show().addClass('invalid');
                                    } else {
                                        $badwordValidationMessage.hide().removeClass('invalid');
                                        if (data.name == 'available') {
                                            // Available!!
                                            $uniqueValidationMessage.hide().removeClass('invalid');
                                            $inTransactionValidationMessage.hide().removeClass('invalid');
                                        } else {
                                            wg_errors.showError(gettext("Unable to verify if name is unique"));
                                        }
                                    }
                                }

                                $nameField.trigger('validated');
                            },
                            failure: function (data) {
                                $badwordValidationMessage.hide().removeClass('invalid');
                                clans.showErrorFromApiResponse(data);
                                $nameField.trigger('validated');
                            },
                            complete: function () {
                                $nameField.parent().removeClass(INPUT_WRAPPER_CHECKING_CLASS);
                            }
                        });
                    }, 400);
                }
            }
        }

        $nameField.trigger('validated');
    }).trigger('input');
};

export function clans_create_onload() {
    $createForm = $(CREATE_FORM_SELECTOR);
    $confirmCreateButton = $(CONFIRM_CREATE_BUTTON_SELECTOR);

    $nameField = $(clans.getFormFieldSelector('name'));
    $tagField = $(clans.getFormFieldSelector('tag'));
    $recruitingPolicyField = $(clans.getFormFieldSelector('recruiting_policy'));

    $confirmCreateButton.on('click tap', showCreateConfirmModal);

    $nameField.on('input propertychange validated', validate);
    $tagField.on('input propertychange validated', validate);
    $recruitingPolicyField.on('click tap', function () {
        validate();
    });

    validate();
};

var old_j = $;
